import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaHeart, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = 2026;

  const quickLinks = [
    { to: '/browse', label: 'Browse Profiles' },
    { to: '/matches', label: 'Find Matches' },
    { to: '/pricing', label: 'Pricing Plans' },
    { to: '/register', label: 'Register Free' },
    { to: '/login', label: 'Login' },
  ];

  const aboutLinks = [
    { to: '/about', label: 'About Us' },
    { to: '/privacy', label: 'Privacy Policy' },
    { to: '/terms', label: 'Terms of Service' },
    { to: '/faq', label: 'FAQ' },
    { to: '/contact', label: 'Contact Us' },
  ];

  const socialLinks = [
    { icon: FaFacebook, href: 'https://facebook.com', label: 'Facebook', color: 'hover:text-blue-400' },
    { icon: FaInstagram, href: 'https://instagram.com', label: 'Instagram', color: 'hover:text-pink-400' },
    { icon: FaTwitter, href: 'https://twitter.com', label: 'Twitter', color: 'hover:text-sky-400' },
    { icon: FaYoutube, href: 'https://youtube.com', label: 'YouTube', color: 'hover:text-red-400' },
  ];

  return (
    <footer className="bg-[#8B0000] text-[#FFF8F0]">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Column */}
          <div className="space-y-4">
            <div>
              <h3 className="text-[#FFD700] text-2xl font-bold font-['Noto_Sans_Devanagari']">
                विवाह आरंभ
              </h3>
              <p className="text-[#B8860B] text-xs tracking-wider font-['Playfair_Display'] mt-0.5">
                Vivah Arambh
              </p>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed font-['Noto_Sans_Devanagari']">
              विश्वासार्ह मराठी वैवाहिक सेवा. तुमच्या आयुष्याचा जोडीदार शोधा, आमच्या अत्याधुनिक AI मॅचमेकिंगसह.
            </p>
            <p className="text-xs text-gray-400 italic">
              Trusted Marathi Matrimonial Service. Find your life partner with our advanced AI matchmaking.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg font-['Playfair_Display'] mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map(link => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-gray-300 hover:text-[#FFD700] transition-colors duration-200 flex items-center space-x-2"
                  >
                    <span className="text-[#B8860B] text-xs">▸</span>
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg font-['Playfair_Display'] mb-4">
              Contact Us
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm text-gray-300">
                <FaMapMarkerAlt className="text-[#B8860B] mt-1 flex-shrink-0" />
                <span>Pune, Maharashtra, India</span>
              </li>
              <li>
                <a
                  href="tel:+919876543210"
                  className="flex items-center space-x-3 text-sm text-gray-300 hover:text-[#FFD700] transition-colors"
                >
                  <FaPhone className="text-[#B8860B] flex-shrink-0" />
                  <span>+91 98765 43210</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@vivaharambh.com"
                  className="flex items-center space-x-3 text-sm text-gray-300 hover:text-[#FFD700] transition-colors"
                >
                  <FaEnvelope className="text-[#B8860B] flex-shrink-0" />
                  <span>info@vivaharambh.com</span>
                </a>
              </li>
            </ul>

            {/* About Links */}
            <div className="mt-4 pt-4 border-t border-[#a50000]">
              <ul className="space-y-2">
                {aboutLinks.map(link => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-gray-300 hover:text-[#FFD700] transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg font-['Playfair_Display'] mb-4">
              Follow Us
            </h4>
            <div className="flex space-x-4 mb-6">
              {socialLinks.map(social => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className={`bg-[#6d0000] p-3 rounded-full text-gray-300 ${social.color} transition-all duration-200 hover:scale-110 hover:shadow-lg`}
                >
                  <social.icon className="text-lg" />
                </a>
              ))}
            </div>

            <div className="bg-[#6d0000] rounded-lg p-4">
              <p className="text-sm text-[#FFD700] font-semibold mb-2 font-['Noto_Sans_Devanagari']">
                आजच नोंदणी करा!
              </p>
              <p className="text-xs text-gray-300 mb-3">
                Register today and find your perfect match.
              </p>
              <Link
                to="/register"
                className="inline-block bg-[#FFD700] text-[#8B0000] px-4 py-2 rounded-full text-sm font-bold hover:bg-[#B8860B] hover:text-white transition-colors"
              >
                Free Registration
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#a50000]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between space-y-2 sm:space-y-0">
            <p className="text-xs text-gray-400 text-center sm:text-left">
              &copy; {currentYear} Vivah Arambh. Developed by{' '}
              <a
                href="https://lyftek.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#FFD700] hover:text-[#B8860B] transition-colors font-medium"
              >
                Lyftek Solutions
              </a>
            </p>
            <p className="text-xs text-gray-400 flex items-center space-x-1">
              <span>Made with</span>
              <FaHeart className="text-[#DC143C] text-xs" />
              <span>in Maharashtra</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
